var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{staticStyle:{"margin-left":"15px"},attrs:{"items":_vm.items,"label":"Selecteer","outlined":"","error":_vm.errors,"attach":""},on:{"change":function($event){return _vm.update()}},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}}),_c('div',{staticClass:"dropdown-spacer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }